import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { AUTOMATION_STEP_MUTATION_SCOPE, AUTOMATION_TEMPLATE_MUTATION_KEY } from '../Automation/queryKeys';

interface Params {
	templateId: string;
	stepId: string;
	impersonationContext?: Api.IImpersonationContext;
	attachmentId: string;
}

export function useAutomationTemplateStepEmailAttachmentDeleteMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IEmailAutomationStep, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: Params) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		scope: AUTOMATION_STEP_MUTATION_SCOPE,
		mutationFn: ({ templateId, stepId, impersonationContext, attachmentId }: Params) => {
			return userSession.webServiceHelper.callAsync<Api.IEmailAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/Email/${encodeURIComponent(
						stepId
					)}/Attachment/${encodeURIComponent(attachmentId)}`,
					impersonationContext,
				}),
				'DELETE',
				null
			);
		},
		onError,
		onSuccess,
	});
}
